// import React, { useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import "../VivaExam/VivaInstructions.css";
// import { Card } from "@mui/material";
// import "../Final_Css/positiveflowbuttons.css";

// const DummyVivaInstructions = () => {
//     const [isChecked, setIsChecked] = useState(false);
//     const [loading, setLoading] = useState(false);

//     const navigate = useNavigate();
//     const { ee_id } = useParams();

//     // ── Hardcoded instructions (you can easily change them here) ──
//     const instructions = [
//         {
//             heading: "General Guidelines",
//             points: [
//                 "This is a viva examination. Be prepared to explain your answers verbally.",
//                 "Keep your camera and microphone on throughout the exam.",
//                 "Do not use any reference material unless explicitly allowed.",
//                 "Maintain complete silence in your surroundings.",
//                 "Any suspicious activity will lead to disqualification.",
//                 "Ensure you are in a well-lit, quiet environment.",
//                 "Test your audio and video before clicking 'Start Exam'.",
//                 "Close all other applications and browser tabs.",
//                 "You will have only one attempt to start the viva.",
//                 "Answer clearly and confidently.",
//                 "Look at the camera while speaking.",
//                 "You will have limited time for each question.",
//                 "Do not leave the screen until the exam is officially completed."
//             ]
//         }
//     ];

//     const enterFullscreen = async () => {
//         const elem = document.documentElement;
//         try {
//             if (elem.requestFullscreen) await elem.requestFullscreen();
//             else if (elem.webkitRequestFullscreen) await elem.webkitRequestFullscreen();
//             else if (elem.msRequestFullscreen) await elem.msRequestFullscreen();
//         } catch (err) {
//             console.warn("Fullscreen request failed:", err);
//             // Many examiners still allow exam even if fullscreen fails
//         }
//     };

//     const handleStartExam = async () => {
//         try {
//             setLoading(true);

//             await enterFullscreen();

//             const storedQuestionIds = JSON.parse(localStorage.getItem("vivaQIds")) || [];

//             if (storedQuestionIds.length === 0) {
//                 alert("No questions found in local storage.\nPlease refresh or contact support.");
//                 setLoading(false);
//                 return;
//             }

//             // ── For demo/development: just simulate exam session id ──
//             const fakeSessionId = `viva-session-${Date.now()}-${Math.floor(Math.random() * 10000)}`;

//             localStorage.setItem("vivaExamSessionId", fakeSessionId);

//             console.log("Mock Viva exam started → Session:", fakeSessionId);
//             console.log("Questions:", storedQuestionIds);

//             // Navigate to exam page
//             navigate(`/dummy-viva-exam}`);

//         } catch (error) {
//             console.error("Error while starting exam:", error);
//             alert("Something went wrong. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleCloseInstructions = () => {
//         window.history.back();
//     };

//     return (
//         <div className="exam-popup-overlay">
//             <Card className="exam-popup-container">
//                 <header className="exam-instructions-header">
//                     <h2>Viva Exam Instructions</h2>
//                 </header>

//                 <main className="exam-instructions-body">
//                     {instructions.map((section, sIdx) => (
//                         <div key={sIdx} className="instruction-section">
//                             {section.heading && (
//                                 <h3 className="instruction-heading">{section.heading}</h3>
//                             )}

//                             <ol className="instruction-list">
//                                 {section.points.map((point, pIdx) => (
//                                     <li key={pIdx} className="instruction-item">
//                                         {point}
//                                     </li>
//                                 ))}
//                             </ol>
//                         </div>
//                     ))}


//                     <div className="checkbox-container tour-checkbox">   
//                         <input
//                             type="checkbox"
//                             id="confirm-read"
//                             checked={isChecked}
//                             onChange={() => setIsChecked(!isChecked)}
//                             style={{ accentColor: "var(--theme-accent)" }}
//                         />
//                         <label htmlFor="confirm-read">
//                             I have read and understood the instructions
//                         </label>
//                     </div>

//                     <div className="buttons-container">
//                         <button className="btn-negative" onClick={handleCloseInstructions} disabled={loading}>
//                             Cancel
//                         </button>

//                         <button
//                             className="btn proceed-btn"          
//                             disabled={!isChecked || loading}
//                             onClick={handleStartExam}
//                         >
//                             {loading ? "Starting..." : "Start Exam"}
//                         </button>
//                     </div>
//                 </main>
//             </Card>
//         </div>
//     );
// };

// export default DummyVivaInstructions;



// src/pages/DummyVivaInstructions.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card } from "@mui/material";
import { TourProvider, useTour } from "../User/TourContext"; // adjust path
import GuidedTour from "../User/GuidedTour";           // adjust path
import { vivaTourSteps } from "../User/tourSteps";       // adjust path

import "../VivaExam/VivaInstructions.css";
import "../Final_Css/positiveflowbuttons.css";

function InstructionsContent() {
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDemoMode, setIsDemoMode] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { run, stepIndex, setStepIndex, startTour, setRun } = useTour();

  // useEffect(() => {
  //   // Auto-start tour when coming from "Demo" button
  //   if (location.state?.fromDemo === true && !run) {
  //     startTour();
  //     setStepIndex(0);
  //     // Clean navigation state so refresh doesn't restart tour
  //     navigate("", { replace: true, state: {} });
  //   }
  // }, [location.state, run, startTour, setStepIndex, navigate]);

  useEffect(() => {
  if (location.state?.fromDemo === true) {
    setIsDemoMode(true);   // ✅ SAVE demo mode

    if (!run) {
      startTour();
      setStepIndex(0);
    }

    // clear state AFTER saving
    navigate("", { replace: true, state: {} });
  }
}, []);

  const instructions = [
    {
      heading: "General Guidelines",
      points: [
        "This is a viva examination. Be prepared to explain your answers verbally.",
        "Keep your camera and microphone on throughout the exam.",
        "Do not use any reference material unless explicitly allowed.",
        "Maintain complete silence in your surroundings.",
        "Any suspicious activity will lead to disqualification.",
        "Ensure you are in a well-lit, quiet environment.",
        "Test your audio and video before clicking 'Start Exam'.",
        "Close all other applications and browser tabs.",
        "You will have only one attempt to start the viva.",
        "Answer clearly and confidently.",
        "Look at the camera while speaking.",
        "You will have limited time for each question.",
        "Do not leave the screen until the exam is officially completed.",
      ],
    },
  ];

  const enterFullscreen = async () => {
    const elem = document.documentElement;
    try {
      if (elem.requestFullscreen) await elem.requestFullscreen();
      else if (elem.webkitRequestFullscreen) await elem.webkitRequestFullscreen();
      else if (elem.msRequestFullscreen) await elem.msRequestFullscreen();
    } catch (err) {
      console.warn("Fullscreen request failed:", err);
    }
  };

  const handleStartExam = async () => {
    try {
      setLoading(true);
      await enterFullscreen();

      if (!isDemoMode) {
        const storedQuestionIds = JSON.parse(localStorage.getItem("vivaQIds")) || [];

        if (storedQuestionIds.length === 0) {
          alert("No questions found in local storage.\nPlease refresh or contact support.");
          setLoading(false);
          return;
        }
      }
      const fakeSessionId = `viva-session-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
      localStorage.setItem("vivaExamSessionId", fakeSessionId);

      console.log("Mock Viva exam started → Session:", fakeSessionId);

      // 🔥 TOUR LOGIC ADDED HERE

      // Increase tour step before navigation
      setStepIndex(stepIndex + 1);

      // Persist step so next page knows where to continue
      localStorage.setItem("tourStep", (stepIndex + 1).toString());

      // Navigate to next page
      navigate("/dummy-viva-exam");

    } catch (error) {
      console.error("Error starting exam:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseInstructions = () => {
    setStepIndex((prev) => prev + 1);
  };

  // In both pages (e.g. InstructionsPage.jsx and DummyVivaExam.jsx)
  useEffect(() => {
    if (location.state?.resumeTour) {
      setStepIndex(location.state.resumeStep ?? 0);
      // Do NOT clear state here – preserves questionStatus, currentQuestion, etc.
    }
  }, [location.state]);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tourStepParam = params.get("tourStep");

    if (tourStepParam !== null) {
      const targetStep = Number(tourStepParam);
      if (!isNaN(targetStep) && targetStep >= 0 && targetStep < vivaTourSteps.length) {
        setStepIndex(targetStep);
      }
      navigate(location.pathname, { replace: true });
    }
  }, [location.search, navigate, setStepIndex, vivaTourSteps.length]);

  return (
    <>
      <div className="exam-popup-overlay">
        <Card className="exam-popup-container">
          <header className="exam-instructions-header">
            <h2>Viva Exam Instructions</h2>
          </header>

          <main className="exam-instructions-body">
            {instructions.map((section, sIdx) => (
              <div key={sIdx} className="instruction-section">
                {section.heading && (
                  <h3 className="instruction-heading">{section.heading}</h3>
                )}
                <ol className="instruction-list">
                  {section.points.map((point, pIdx) => (
                    <li key={pIdx} className="instruction-item">
                      {point}
                    </li>
                  ))}
                </ol>
              </div>
            ))}

            <div className="checkbox-container tour-checkbox">
              <input
                type="checkbox"
                id="confirm-read"
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
                style={{ accentColor: "var(--theme-accent)" }}
              />
              <label htmlFor="confirm-read">
                I have read and understood the instructions
              </label>
            </div>

            <div className="buttons-container">
              <button
                className="btn-negative"
                onClick={handleCloseInstructions}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="proceed-btn"
                disabled={!isChecked || loading}
                onClick={handleStartExam}
              >
                {loading ? "Starting..." : "Start Exam"}
              </button>
            </div>
          </main>
        </Card>
      </div>

      {/* The actual tour overlay & tooltip */}
      {run && (
        <GuidedTour
          steps={vivaTourSteps}
          stepIndex={stepIndex}
          setStepIndex={setStepIndex}
          onFinish={() => setRun(false)}
        />
      )}
    </>
  );
}

export default InstructionsContent;



